import { createRoot } from 'react-dom/client'
import { PostHogProvider } from 'posthog-js/react'
import App from './App.tsx'
import './index.css'
import { config, isPostHogEnabled } from './lib/config'

const options = {
  api_host: config.posthog.apiHost,
  capture_pageview: false, // We'll handle this manually in the app
  capture_pageleave: true,
  session_recording: {
    maskAllInputs: false,
    maskInputOptions: {},
    maskTextSelector: null,
    recordCrossOriginIframes: false,
  },
  autocapture: true,
  disable_session_recording: false,
  enable_recording_console_log: true,
}

// Conditionally render with or without PostHogProvider
const AppWrapper = () => {
  if (isPostHogEnabled()) {
    return (
      <PostHogProvider 
        apiKey={config.posthog.apiKey}
        options={options}
      >
        <App />
      </PostHogProvider>
    )
  } else {
    return <App />
  }
}

createRoot(document.getElementById("root")!).render(<AppWrapper />);
